<template>
  <div
    class="modal fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-10 dw-lg-8 dw-xl-7"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">{{ title }}</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div v-if="rows.length" class="table-responsive">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th v-for="column in columns" :key="column">{{ heading(column) }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                  <td v-for="column in columns" :key="column">{{ row[column] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="text-muted">No data to display.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CModal } from '@chameleon/chameleon-vue'
import { startCase } from 'lodash'

export default {
  extends: CModal,

  data () {
    return {
      title: 'Data',
      rows: []
    }
  },

  computed: {
    columns () {
      return this.rows.length ? Object.keys(this.rows[0]) : []
    }
  },

  methods: {
    heading (column) {
      return startCase(column)
    }
  }
}
</script>
